var map = {
	"./app.svg": 49849,
	"./fail.svg": 741,
	"./logo.svg": 79443,
	"./more.svg": 99097,
	"./reload.svg": 59610,
	"./sina.svg": 8868,
	"./success.svg": 16744,
	"./warning.svg": 94238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;